import React from "react";
import { Box, Button, TextField } from "@mui/material";
import DialogComponent from "components/DialogComponent";
import { useFormik } from "formik";
import * as yup from "yup";
import { useCreateFolderMutation } from "store/slices/apis/dmsSlice";
import { useParams } from "react-router-dom";
import CustomButton from "components/Button";
import { useDispatch } from "react-redux";
import { closeSnackbar, openSnackbar } from "store/slices/snackbar";

const validationSchema = yup.object({
    folderName: yup
        .string()
        .required("Folder name is required")
        .min(2, "Name is too short"),
});

const CreateFolder = ({ open, handleClose, selectedFolderId, onSuccess }) => {
    const { projectId } = useParams();
    const [createFolder, { isLoading }] = useCreateFolderMutation();
    const dispatch = useDispatch();
    const formik = useFormik({
        initialValues: {
            folderName: "",
        },
        validationSchema: validationSchema,
        onSubmit: async (values, { resetForm }) => {
            try {
                // const payload = {
                //     projectId: projectId,
                //     folderName: values.folderName,
                //     parentFolderId: selectedFolderId || null,
                // };
                const formData = new FormData();
                formData.append("ProjectId", projectId);
                formData.append("FolderName", values.folderName);
                formData.append("CreatedBy", "Ajay");
                if (selectedFolderId) {
                    formData.append("ParentFolderId", selectedFolderId);
                }

                const result = await createFolder(formData).unwrap();
                if (result?.status === "Success") {
                    openNotification("Folder Created Successfully", "success")
                    onSuccess(selectedFolderId);
                    resetForm();
                    handleClose();

                }

            } catch (error) {
                openNotification(error?.data?.message || "Folder Creation Failed")
                console.error("Folder creation failed:", error);
            }
        },
    });


    const openNotification = (msg, type = "error", duration = 5000) => {
        dispatch(
            openSnackbar({
                open: true,
                message: msg,
                variant: 'alert',
                alert: {
                    color: type
                },
                close: false
            })
        );
        setTimeout(() => dispatch(closeSnackbar()), duration);
    };
    return (
        <DialogComponent
            title="Add New Folder"
            open={open}
            handleClose={handleClose}
        >
            <form onSubmit={formik.handleSubmit}>
                <TextField
                    fullWidth
                    name="folderName"
                    label="Folder Name"
                    variant="outlined"
                    margin="dense"
                    value={formik.values.folderName}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.folderName && Boolean(formik.errors.folderName)}
                    helperText={formik.touched.folderName && formik.errors.folderName}
                />
                <Box
                    sx={{ mt: 2, display: "flex", justifyContent: "flex-end", gap: 1 }}
                >
                    {/* <CustomButton
                        label="Cancel"
                        onClick={handleClose}
                        sx={{
                            backgroundColor: "#F9FAFB",
                            color: "#4B5563",
                            border: "1px solid #E5E7EB",
                            "&:hover": { backgroundColor: "#F3F4F6" },
                        }}
                    /> */}
                    <Button onClick={handleClose}
                        sx={{
                            textTransform: "none",
                            color: "#F15744",
                            fontSize: "14px",
                            lineHeight: "100%",
                            fontFamily: "Outfit, sans-serif",
                            borderRadius: "25px",
                            fontWeight: 500,
                            px: "20px",
                            py: "15px",
                        }}>
                        Cancel
                    </Button>
                    {/* <CustomButton
                        label={isLoading ? "Saving..." : "Create"}
                        type="submit"
                        disabled={isLoading}
                        sx={{ backgroundColor: "#00344C", color: "#fff" }}
                    /> */}
                    <Button
                        type="submit"
                        variant="contained"
                        loading={isLoading}
                        sx={{
                            backgroundColor: "#00344C",
                            borderRadius: "25px",
                            textTransform: "none",
                            fontWeight: 500,
                            fontSize: "14px",
                            lineHeight: "100%",
                            fontFamily: "Outfit, sans-serif",
                            color: "#FFFFFF",
                            px: "20px",
                            py: "15px",
                        }}
                        disabled={isLoading}
                    >
                        Save
                    </Button>
                </Box>
            </form>
        </DialogComponent>
    );
};

export default CreateFolder;
